import React from 'react';
import { Center, Container } from '@chakra-ui/react';

import { BlankLayoutContainer } from '~/pages/_layouts/BlankLayout/BlankLayout_Styles';

type BlankLayoutProps = {
  children: any;
};

export default function BlankLayout({ children }: BlankLayoutProps) {
  return (
    <BlankLayoutContainer>
      <Container maxW="100%" width="100%" height="100vh" px={0}>
        <Center minH="100vh">{children}</Center>
      </Container>
    </BlankLayoutContainer>
  );
}
